/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Typography,
  Chip,
  FormControl,
  TextField as MuiTextField,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { TextField, Select } from '../../../irmlib/src/components/FormControls'
import { useFormPageHandler } from '../../../irmlib/src/hooks'
import { useTranslation } from 'react-i18next'
import { successToast } from '../../../common/functions'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'

const DEVICE_NAME = 0
const DEVICE_IP = 1
const DEVICE_PORT = 2
const ASSIGNED_COUNTRY = 3

// IPv4: four octets 0-255
const IPV4_REGEX = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/
// IPv6 (simplified: 8 groups of 1-4 hex digits, colons)
const IPV6_REGEX = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^(?:(?:[0-9a-fA-F]{1,4}:)*[0-9a-fA-F]{1,4})?::(?:(?:[0-9a-fA-F]{1,4}:)*[0-9a-fA-F]{1,4})?$/

const isValidIP = (value) => {
  if (!value || typeof value !== 'string') return false
  const trimmed = value.trim()
  return IPV4_REGEX.test(trimmed) || IPV6_REGEX.test(trimmed)
}

const isValidPort = (value) => {
  if (value === '' || value == null) return false
  const num = Number(value)
  return Number.isInteger(num) && num >= 1 && num <= 65535
}

const getService = async () => Promise.resolve({})

const AddNewDeviceModal = ({ open, onClose, onAddCustomer, isEditMode = false, editData = null, alreadyAssignedDistrictIds = [] }) => {
  const { t } = useTranslation()
  const [assignedCountry, setAssignedCountry] = useState('')
  const [assignedDistricts, setAssignedDistricts] = useState([])
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [districts, setDistricts] = useState([])
  const assignedSet = React.useMemo(() => new Set((alreadyAssignedDistrictIds || []).map(String)), [alreadyAssignedDistrictIds])
  const districtOptions = React.useMemo(() => {
    if (isEditMode) return districts
    return districts.filter((d) => !assignedSet.has(String(d.value)))
  }, [districts, isEditMode, assignedSet])
  const [errorMessage, setErrorMessage] = useState('')
  const refLocalBusyCursor = useRef(null)

  const formTemplate = [
    { label: 'Device Name *', fieldKey: 'deviceName', defaultValue: '', isRequired: true },
    { label: 'Device IP *', fieldKey: 'deviceIP', defaultValue: '', isRequired: true },
    { label: 'Device Port *', fieldKey: 'devicePort', defaultValue: '', isRequired: true },
    { label: 'Assigned Country *', fieldKey: 'assignedCountry', defaultValue: '', isRequired: true },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

    const getCountries = async () => {
    try {
      const countriesData = await localGdeTransactions.getCountries()
      const countriesList = countriesData.docs.map((doc) => ({
        value: doc.data().countryName || doc.id,
        label: doc.data().countryName || doc.id,
      }))
      setCountries(countriesList)
    } catch (error) {
      console.error('Error getting countries:', error)
    }
  }

  // Only run when modal opens
  useEffect(() => {
    if (!open) return
    getCountries()
    if (isEditMode && editData) {
      setAssignedCountry(editData.assignedCountry || '')
      const raw = editData.assignedDistricts
      const districtIds = Array.isArray(raw)
        ? raw
        : raw && typeof raw === 'object'
          ? Object.keys(raw)
          : []
      setAssignedDistricts(districtIds)
      setTimeout(() => {
        if (arrRefs[DEVICE_NAME]?.current) arrRefs[DEVICE_NAME].current.setValue(editData.deviceName || '')
        if (arrRefs[DEVICE_IP]?.current) arrRefs[DEVICE_IP].current.setValue(editData.deviceIP || '')
        if (arrRefs[DEVICE_PORT]?.current) arrRefs[DEVICE_PORT].current.setValue(editData.devicePort || '')
        if (arrRefs[ASSIGNED_COUNTRY]?.current) arrRefs[ASSIGNED_COUNTRY].current.setValue(editData.assignedCountry || '')
      }, 100)
    } else {
      setAssignedCountry('')
      setAssignedDistricts([])
      setTimeout(() => {
        arrRefs.forEach((r) => r?.current?.clear?.())
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

 useEffect(() => {
  const loadDistricts = async () => {
    if (!assignedCountry) {
      setDistricts([])
      return
    }

    try {
      const districtsData = await localGdeTransactions.getDistrictsByCountry(assignedCountry)
      const districtsList = districtsData.docs.map((doc) => ({
        value: String(doc.id),
        label: doc.data().districtName || doc.id,
      }))

      setDistricts(districtsList)

      // If edit mode, set selected AFTER districts load
      if (isEditMode && editData?.assignedDistricts) {
        const raw = editData.assignedDistricts
        const districtIds = Array.isArray(raw)
          ? raw.map(String)
          : typeof raw === 'object'
            ? Object.keys(raw).map(String)
            : []

        setAssignedDistricts(districtIds)
      }
    } catch (error) {
      console.error('Error getting districts:', error)
    }
  }

  loadDistricts()
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [assignedCountry])


  const handleValidate = async () => {
    setErrorMessage('')
    const deviceName = (arrRefs[DEVICE_NAME]?.current?.getValue?.() || '').trim()
    const deviceIP = (arrRefs[DEVICE_IP]?.current?.getValue?.() || '').trim()
    const devicePort = (arrRefs[DEVICE_PORT]?.current?.getValue?.() || '').trim()
    const assignedCountry = arrRefs[ASSIGNED_COUNTRY]?.current?.getValue?.() || ''

    // Validation applies for both Add and Edit
    if (!deviceName) {
      arrRefs[DEVICE_NAME]?.current?.setErrorMsg?.('Required', true)
      return
    }
    if (!deviceIP) {
      arrRefs[DEVICE_IP]?.current?.setErrorMsg?.('Required', true)
      return
    }
    if (!isValidIP(deviceIP)) {
      arrRefs[DEVICE_IP]?.current?.setErrorMsg?.('Enter a valid IP address (e.g. 192.168.1.1)', true)
      return
    }
    if (!devicePort) {
      arrRefs[DEVICE_PORT]?.current?.setErrorMsg?.('Required', true)
      return
    }
    if (!isValidPort(devicePort)) {
      arrRefs[DEVICE_PORT]?.current?.setErrorMsg?.('Enter a valid port (1-65535)', true)
      return
    }
    if (!assignedCountry) {
      arrRefs[ASSIGNED_COUNTRY]?.current?.setErrorMsg?.('Required', true)
      return
    }
    if (!assignedDistricts || assignedDistricts.length === 0) {
      setErrorMessage('At least one Assigned District is required')
      return
    }

    const assignedDistrictsMap = (assignedDistricts || []).reduce((acc, id) => {
      const option = districts.find((d) => d.value === id)
      acc[id] = option?.label ?? id
      return acc
    }, {})

    onAddCustomer({
      deviceName,
      deviceIP,
      devicePort,
      assignedCountry,
      assignedDistricts: assignedDistrictsMap,
    })

    if (!isEditMode) {
      successToast({
        message: 'Device added successfully',
        title: t('toast.success'),
        autoHideDuration: 3000,
        isBlocking: false,
      })
    }
    handleClose()
  }

  const handleClose = () => {
    setErrorMessage('')
    setAssignedCountry('')
    setAssignedDistricts([])
    arrRefs.forEach((r) => r?.current?.clear?.())
    onClose()
  }

  const handleCountryChange = (value) => {
    setAssignedCountry(value || '')
    setAssignedDistricts([])
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return
        if (reason === 'escapeKeyDown') return
        onClose()
      }}
      PaperProps={{
        style: {
          maxWidth: '650px',
          width: '100%',
        },
      }}
      disableEnforceFocus
      disableScrollLock
    >
      <DialogTitle>{isEditMode ? 'Edit Device' : 'Register New Device'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              data={data}
              fieldTemplate={formTemplate[DEVICE_NAME]}
              ref={arrRefs[DEVICE_NAME]}
              noTranslate
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              data={data}
              fieldTemplate={formTemplate[DEVICE_IP]}
              ref={arrRefs[DEVICE_IP]}
              noTranslate
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              data={data}
              fieldTemplate={formTemplate[DEVICE_PORT]}
              ref={arrRefs[DEVICE_PORT]}
              noTranslate
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="none" disabled={isEditMode}>
              <Select
                value={assignedCountry}
                onChange={handleCountryChange}
                data={data}
                items={countries}
                fieldTemplate={formTemplate[ASSIGNED_COUNTRY]}
                ref={arrRefs[ASSIGNED_COUNTRY]}
                noTranslate
                noTranslateItems
                disabled={isEditMode}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              multiple
              options={districtOptions}
              getOptionLabel={(option) => (option && option.label) || ''}
              value={districts.filter((district) => assignedDistricts.includes(String(district.value)))}
              isOptionEqualToValue={(option, value) => String(option.value) === String(value.value)}
              onChange={(event, newValue) => {
                setAssignedDistricts(newValue ? newValue.map((item) => String(item.value)) : [])
              }}
              disabled={!assignedCountry || isEditMode}
              fullWidth
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={option.value}
                    variant="outlined"
                    size="small"
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  variant="standard"
                  fullWidth
                  required
                  label="Assigned Districts"
                  placeholder="Select districts"
                  InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {errorMessage && (
          <Typography
            key={errorMessage}
            paragraph
            style={{
              fontSize: '16px',
              color: '#FFF',
              backgroundColor: '#db4437',
              width: 'fit-content',
              padding: '4px',
              marginTop: '16px',
              flex: 0.96,
            }}
          >
            {errorMessage}
          </Typography>
        )}
        <Button onClick={handleClose} color="default">
          {t('dialogs.cancel')}
        </Button>
        <Button onClick={handleValidate} color="primary" variant="contained" disabled={loading}>
          {loading ? (isEditMode ? 'Updating...' : 'Adding...') : isEditMode ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddNewDeviceModal
